import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { EmptyState } from '../components/EmptyState';
import { useDefaultLessonMutation, useDefaultWeek, useSubjects } from '../planner/api';
import { lastWeek } from '../planner/lastWeek';
import { PlannerSheet } from '../planner/sheet/PlannerSheet';

/** The default timetable: the sheet without dates, day plan or notes. */
export default function RoosterPage() {
  const week = useDefaultWeek();
  const subjects = useSubjects();
  const saveCell = useDefaultLessonMutation();
  const back = lastWeek();

  return (
    <main className="mx-auto my-4 flex w-full max-w-7xl flex-col gap-3 px-3">
      <div
        role="region"
        aria-label="Rooster"
        className="no-print flex flex-wrap items-center gap-3 rounded-md px-4 py-2"
        style={{ background: 'var(--accent)', color: 'var(--on-accent)' }}
      >
        <span className="font-semibold">Je bewerkt het vaste rooster.</span>
        <span className="opacity-90">Een nieuwe week begint hiermee; per week kun je daarna nog aanpassen.</span>
        <Button asChild variant="secondary" className="ml-auto min-h-11 bg-[var(--panel-solid)] text-[var(--text)] hover:bg-[var(--panel-solid)]">
          <Link to={`/week/${back.year}/${back.week}`}>Terug naar deze week</Link>
        </Button>
      </div>
      <PlannerSheet
        periods={week.data?.periods ?? []}
        subjects={subjects.data ?? []}
        lessons={week.data?.lessons ?? []}
        title={<h1 className="text-2xl">Rooster</h1>}
        onCellChange={(cell, value) => saveCell.mutate({ ...cell, ...value })}
      >
        {week.isPending || subjects.isPending ? (
          <p>Laden…</p>
        ) : week.isError || subjects.isError ? (
          <p role="alert">Het rooster kon niet worden geladen. Vernieuw de pagina.</p>
        ) : week.data.periods.length === 0 ? (
          <EmptyState
            title="Nog geen tijdvakken"
            note="Een rooster begint met de tijden van je lesdag."
            action={
              <Button asChild className="mt-2 min-h-11">
                <Link to="/instellingen/tijdvakken">Stel je tijdvakken in</Link>
              </Button>
            }
          />
        ) : (
          subjects.data.length === 0 && (
            <p>
              Je hebt nog geen vakken. <Button asChild variant="link" className="h-auto px-0">
                <Link to="/instellingen/vakken">Voeg eerst vakken toe</Link>
              </Button>.
            </p>
          )
        )}
      </PlannerSheet>
      <p role="status" className="min-h-6 text-sm opacity-70">
        {saveCell.isPending ? 'Opslaan…' : saveCell.isError ? 'Opslaan mislukt. Probeer het opnieuw.' : saveCell.isSuccess ? 'Opgeslagen' : ''}
      </p>
    </main>
  );
}
